// extracted by mini-css-extract-plugin
module.exports = {"localeLinks":"LocaleLinks-module--locale-links--ADg9T","active":"LocaleLinks-module--active--3ykC9"};